import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'paypal',
  version: '1.1.0',
  properties: [
    // Properties will be defined based on n8n equivalents
  ]
};

export default schema;
